<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'common.date.validfrom' | translate }}</label>
    <input appInputDate formControlName="validFrom" [attr.max]="maxValidFrom">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meternumber' | translate }}</label>
    <select appSelect formControlName="meterId">
      <option [value]="null" disabled>{{ 'meteringpoint.meter.selectmeter' | translate }}</option>
      @for (item of meterList; track item.id) {
        <option [value]="item.id">{{ item | meterOptionLabel }}</option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.serialnumber' | translate }}</label>
    <input type="text" appInput formControlName="serialNumber" readonly>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'common.quadrant' | translate }}</label>
    <select appSelect formControlName="quadrant">
      <option [value]="null" disabled>{{ 'common.quadrant' | translate }}</option>
      @for (item of quadrants; track item.key) {
        <option [value]="item.key">
          {{ item.value | translate }}@if (registerFor(item.key); as register) { ({{ register }}) }
        </option>
      }
    </select>
  </app-input-group>
</form>
